import { render, staticRenderFns } from "./ussd.vue?vue&type=template&id=9e63bb8a"
import script from "./ussd.vue?vue&type=script&lang=js"
export * from "./ussd.vue?vue&type=script&lang=js"
import style0 from "./ussd.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/ussd.vue
// module id = y0hZ
// module chunks = 0